import Swiper from 'swiper/bundle';

document.querySelectorAll('.featured-posts--slider.swiper').forEach((block, i) => {

  $(block)
    .append(
      '<div class="swiper-controls"><div class="swiper-button-prev swiper-button"><?xml version="1.0" encoding="UTF-8"?><svg width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg"><path d="m477.91 600 16.77 19.602 181.37 211.6 46.051-39.203-164.6-192 164.6-192-46.051-39.203-181.37 211.6-16.77 19.602z" /></svg></div><div class="swiper-pagination"></div><div class="swiper-button-next swiper-button"><?xml version="1.0" encoding="UTF-8"?><svg width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg"><path d="m722.1 600-16.766-19.602-181.37-211.6-46.051 39.203 164.61 192-164.61 192 46.051 39.203 181.37-211.6z" /></svg>',
    );

  new Swiper(block, {

    loop: true,
    slidesPerView: 'auto',
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: function () {
        console.log('initialized.'); // this works
        //setAlignFullCssVar();
      },
      imagesReady: function () {
        console.log('images ready.'); // this doesn't work
        setAlignFullCssVar();
      },
    },

  });

});

document.querySelectorAll('.slider--items.swiper').forEach((block, i) => {

  $(block)
    .children()
    .addClass('swiper-slide')
    .wrapAll('<div class="swiper-wrapper">');

  $(block)
    .append('<div class="swiper-pagination">')
    .append('<div class="swiper-button-prev swiper-button"><?xml version="1.0" encoding="UTF-8"?><svg width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg"><path d="m477.91 600 16.77 19.602 181.37 211.6 46.051-39.203-164.6-192 164.6-192-46.051-39.203-181.37 211.6-16.77 19.602z" /></svg>')
    .append('<div class="swiper-button-next swiper-button"><?xml version="1.0" encoding="UTF-8"?><svg width="1200pt" height="1200pt" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg"><path d="m722.1 600-16.766-19.602-181.37-211.6-46.051 39.203 164.61 192-164.61 192 46.051 39.203 181.37-211.6z" /></svg>');

  new Swiper(block, {
    
    loop: true,
    slidesPerView: 'auto',
    autoHeight: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: function () {
        console.log('initialized.'); // this works
        //setAlignFullCssVar();
      },
      imagesReady: function () {
        console.log('images ready.'); // this doesn't work
        setAlignFullCssVar();
      },
    },

  });

});